import { Link } from '@tanstack/react-router'
import { CtaButton, ctaLinkClasses } from '@workspace/ui/components/dsm/cta-button'
import {
  SecondaryButton,
  secondaryLinkClasses,
} from '@workspace/ui/components/dsm/secondary-button'
import { cn } from '@workspace/ui/lib/utils'
import { ArrowRight } from 'lucide-react'
import type { ReactNode } from 'react'

export interface CtaBannerProps {
  icon: ReactNode
  iconBg?: string
  title: string
  description: string
  actionLabel: string
  actionTo?: string
  onAction?: () => void
  variant?: 'primary' | 'outline'
}

export function CtaBanner({
  icon,
  iconBg = 'bg-[#f97316]/10',
  title,
  description,
  actionLabel,
  actionTo,
  onAction,
  variant = 'primary',
}: CtaBannerProps) {
  const isPrimary = variant === 'primary'

  return (
    <div
      className={cn(
        'overflow-hidden rounded-xl border',
        isPrimary
          ? 'border-[#f97316]/20 bg-gradient-to-r from-[#f97316]/[0.04] to-transparent'
          : 'border-border bg-card/30'
      )}
    >
      <div className="flex items-center justify-between px-6 py-5">
        <div className="flex items-center gap-4">
          <div className={cn('flex size-10 items-center justify-center rounded-lg', iconBg)}>
            {icon}
          </div>
          <div>
            <h3 className="font-semibold text-foreground">{title}</h3>
            <p className="text-sm text-muted-foreground">{description}</p>
          </div>
        </div>
        {actionTo ? (
          <Link
            to={actionTo}
            className={
              isPrimary ? ctaLinkClasses({ size: 'sm' }) : secondaryLinkClasses({ size: 'sm' })
            }
          >
            <span>{actionLabel}</span>
            <ArrowRight />
          </Link>
        ) : isPrimary ? (
          <CtaButton size="sm" arrow onClick={onAction}>
            {actionLabel}
          </CtaButton>
        ) : (
          <SecondaryButton size="sm" arrow onClick={onAction}>
            {actionLabel}
          </SecondaryButton>
        )}
      </div>
    </div>
  )
}
